import {removeHash} from './removeHash';

export function addHash(target: string = '') {
    return `#${removeHash(target)}`;
}
